import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getTurnsConfig(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/mturn/config', options);
  }

  public updateTurnsConfigHelp(context, lang, udid, assistanceActive) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { assistanceActive };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config', item, options);
  }

  public updateTurnsConfigUI(
    context, lang, udid, broadcastingMode, languageIconMode, backgroundColor,
    textPrimaryColor, textSecondaryColor, takeTurnsFromBroadcast
  ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { broadcastingMode, languageIconMode, backgroundColor, textPrimaryColor, textSecondaryColor, takeTurnsFromBroadcast };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config', item, options);
  }

  public getTurnsCenterConfig(context, lang, udid, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/mturn/config/center', options);
  }

  public updateTurnsCenterConfig(context, lang, udid, centerInternalId, workingMode) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, workingMode };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config/center', item, options);
  }

  public updateTurnsUiBackgroundImage(
    context, lang, udid, backgroundImageUrl
  ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { backgroundImageUrl: backgroundImageUrl };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config', item, options);
  }

  public updateTurnsConfigSatisfaction(context, lang, udid, satisfactionActive) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { satisfactionActive };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config', item, options);
  }

  public updateTurnsConfigImageTicket(context, lang, udid, imageTicket) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { imageTicket };
    return this.http.patch(this.BASE_URL + 'private/v2.0/mturn/config', item, options);
  }
}
